<template>
  <div id="all" title="Overzichtskaart">
    <div class="panel screen" id="layers" v-if="kaart" @click="layerClick">
      <img class="logo" src="../assets/layers.svg">
      <Layers id="LayersOverview" v-if="kaart" :class="{visible: showLayers}"/>
    </div>
    <div class="panel screen" id="plus" v-if="kaart" @click="zoomIn">
      <img class="logo" src="../assets/cross.svg">
    </div>
    <div class="panel screen" id="min" v-if="kaart" @click="zoomOut">
      <img class="logo" src="../assets/min.svg">
    </div>
    <div
      v-if="kaart"
      class="panel screen"
      id="north"
      title="Klik om de kaart op het noorden te oriënteren"
    >
      <img class="logo" src="../assets/compas.svg" :style="north" @click="setNorth">
    </div>
    <div v-else class="panel screen unclickable" id="north" title="Noordpijl">
      <img class="logo" src="../assets/compas.svg" :style="north">
    </div>
    <div class="circle-shadow"></div>
    <div class="circle" id="OverviewMap" title="Overzichtskaart">
      <div class="panel mobiel" id="north">
        <img v-if="kaart" class="logo" src="../assets/compas.svg" :style="north" @click="setNorth">
        <img v-else class="logo" src="../assets/compas.svg" :style="north">
      </div>
      <div class="MiniMap" title="Overzichtskaart">
        <MglMap
          :mapStyle="mapStyle"
          @load="onMapLoad"
          :center="center"
          :zoom="zoom"
          :trackResize="true"
          :interactive="false"
          :attributionControl="false"
        >
          <MglGeojsonLayer
            sourceId="geojsonsource"
            :source="activeboundingbox"
            layerId="boundingbox"
            :layer="geoJsonLayer"
            :clearSource="false"
            :interactive="false"
          />
        </MglMap>
      </div>
    </div>
    <div class="panel mobiel" id="layers" v-if="kaart" @click="layerClick">
      <img class="logo" src="../assets/layers.svg">
      <Layers id="LayersOverview" v-if="kaart" :class="{visible: showLayers}"/>
    </div>
  </div>
</template>

<style>
.visible {
  visibility: visible !important;
}
#all {
  position: absolute;
  width: 300px;
  height: 100%;
}
.mobiel {
  visibility: visible;
  z-index: 1000;
}
.screen {
  visibility: hidden;
}
.panel {
  position: absolute;
  background: #7897b5;
  width: 30px;
  height: 35px;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.25);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  pointer-events: auto;
}
.panel img {
  width: 15px;
  min-height: 18px;
}
#north {
  top: 170px;
  bottom: 0px;
  left: 87px;
}
#north.unclickable {
  cursor: default;
}
#layers {
  top: 203px;
  left: 87px;
}
#LayersOverview {
  visibility: hidden;
  position: absolute;
  top: 35px;
  right: 0px;
}

#plus {
  top: 60px;
  left: 0px;
}
#min {
  top: 60px;
  left: 120px;
}
.circle-shadow {
  position: absolute;
  height: 124px;
  width: 124px;
  border-radius: 50%;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.25);
}
.circle {
  position: absolute;
  background: #55574a;
  height: 204px;
  width: 204px;
  clip-path: circle(102px at 102px 102px);
}
.MiniMap {
  position: absolute;
  top: 2px;
  left: 2px;
  height: 200px;
  width: 200px;
  box-sizing: border-box;
  clip-path: circle(100px at 100px 100px);
}
.MiniMap .mapboxgl-canvas {
  height: 200px !important;
  width: 200px !important;
}
@media (min-width: 768px) {
  .circle {
    height: 124px;
    width: 124px;
    clip-path: circle(62px at 62px 62px);
  }
  .MiniMap {
    height: 120px;
    width: 120px;
    clip-path: circle(60px at 60px 60px);
  }
  .MiniMap .mapboxgl-canvas {
    height: 120px !important;
    width: 120px !important;
  }
  #north {
    top: -30px;
    left: 47px;
  }
  #layers {
    top: 120px;
    left: 47px;
  }
  #plus {
    top: 45px;
    left: -25px;
  }
  #min {
    top: 45px;
    left: 120px;
  }
  .mobiel {
    visibility: hidden;
  }
  .screen {
    visibility: visible;
  }
}
</style>

<script>
import { MglMap, MglGeojsonLayer } from "vue-mapbox";
import Layers from "../components/Layers.vue";

export default {
  props: ["kaart"],
  components: {
    MglMap,
    MglGeojsonLayer,
    Layers
  },
  data() {
    return {
      mapStyle: "/nimh_minimap_v2.json",
      geoJsonLayer: {
        type: "fill",
        paint: {
          "fill-color": "#55574A",
          "fill-opacity": 0.6
        }
      },
      showLayers: false
    };
  },
  methods: {
    async onMapLoad(event) {
      this.map = event.map;
      this.map.resize();
    },
    layerClick() {
      this.showLayers = this.showLayers ? false : true;
    },
    zoomIn() {
      this.$store.commit("map/setZoom", this.$store.state.map.zoom + 1);
    },
    zoomOut() {
      this.$store.commit("map/setZoom", this.$store.state.map.zoom - 1);
    },
    setNorth() {
      this.$store.commit("map/setNorth", 0);
    }
  },
  created() {
    // We need to set mapbox-gl library here in order to use it in template
    this.map = null;
  },
  computed: {
    north() {
      let deg = 360 - this.$store.state.map.north;
      return "transform: rotate(" + deg + "deg);";
    },
    zoom() {
      let zoom = this.$store.state.map.zoom - 5;
      return zoom > 0 ? zoom : 0;
    },
    center() {
      let lat = this.$store.state.map.center.lat;
      let lng = this.$store.state.map.center.lng;
      return [lng, lat];
    },
    activeboundingbox() {
      let coordinates = this.$store.state.map.activebounds;
      let geojsonsource = {
        data: {
          id: "geojsonsource",
          type: "FeatureCollection",
          features: [
            {
              type: "Feature",
              properties: {},
              geometry: {
                type: "Polygon",
                coordinates: [coordinates]
              }
            }
          ]
        }
      };
      return geojsonsource;
    }
  },
  updated: function() {
    if (this.map) this.map.resize();
  }
};
</script>
